module.exports = __webpack_public_path__ + "static/media/Web 1920 – 1.8a55d6f6.svg";